// extracted by mini-css-extract-plugin
export var cruiseMarketingName = "SpecialVoyageInfoSummary-module--cruise-marketing-name--77a74";
export var cruiseRecap = "SpecialVoyageInfoSummary-module--cruise-recap--ecb12";
export var ctaButtons = "SpecialVoyageInfoSummary-module--cta-buttons--f9a00";
export var ctaContainers = "SpecialVoyageInfoSummary-module--cta-containers--906e0";
export var heroImage = "SpecialVoyageInfoSummary-module--hero-image--c782a";
export var priceRecap = "SpecialVoyageInfoSummary-module--price-recap--cc27f";
export var promoBadgesContainer = "SpecialVoyageInfoSummary-module--promo-badges-container--17097";
export var wrapper = "SpecialVoyageInfoSummary-module--wrapper--fbc4a";